import SearchableDropdown from "../../ui/tableDataDropdowns/SearchableDropdown";

const TemplateBrokerHeader = ({ data, setFilter, loading }) => {
  return (
    <div className="mt-3 flex items-baseline gap-6 max-sm:hidden ">
      <div className="mb-8 flex w-full flex-wrap items-baseline gap-6">
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-2 ">
            <label className="text-[14px] font-[400] text-[#868686]">
              Template Name
            </label>
            <SearchableDropdown
              data={data}
              valueKey={"template_id"}
              displayKey={"vendor_or_template_name"}
              filterKey={"template_id"}
              setFilter={(val) => {
                setFilter((prev) => ({ ...prev, template_id: val }));
              }}
              label={"Template Name"}
              type={"searchable"}
              loading={loading}
            />
          </div>
        </div>

        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-2 ">
            <label className="text-[14px] font-[400] text-[#868686]">
              Broker Name
            </label>
            <SearchableDropdown
              data={data}
              valueKey={"broker_id"}
              displayKey={"broker_name"}
              filterKey={"broker_id"}
              setFilter={(val) => {
                setFilter((prev) => ({ ...prev, broker_id: val }));
              }}
              label={"Broker Name"}
              type={"searchable"}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateBrokerHeader;
